import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NWClient } from '../../client/NWClient';
import { revertAll, RootState } from '../../store';

export const fetchFileBlob = createAsyncThunk(
  'fileBlob/fetch',
  async (docId: number, { rejectWithValue }) => {
    try {
      const response: string = await NWClient.getDocumentBlob(docId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An unexpected error occurred'
      );
    }
  }
);

interface fileBlobState {
  fileBlobURL: string | null;
  blobMode: boolean;
  status: string;
  error: string;
}

const initialState: fileBlobState = {
  fileBlobURL: null,
  blobMode: true,
  status: 'idle',
  error: '',
};

const fileBlobSlice = createSlice({
  name: 'fileBlob',
  initialState,
  reducers: {
    setFileBlobURL(state, action: PayloadAction<string>) {
      state.fileBlobURL = action.payload;
    },
    setBlobMode(state, action: PayloadAction<boolean>) {
      state.blobMode = action.payload;
    },
    resetFileBlob() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchFileBlob.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(fetchFileBlob.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.fileBlobURL = action.payload;
      })
      .addCase(fetchFileBlob.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? '';
      })
      .addCase(revertAll, () => initialState);
  },
});

export const { setFileBlobURL, setBlobMode, resetFileBlob } = fileBlobSlice.actions;

export default fileBlobSlice.reducer;

export const selectFileBlobURL = (state: RootState) => state.fileBlob.fileBlobURL;
export const selectFileBlobMode = (state: RootState) => state.fileBlob.blobMode;
export const selectFileBlobStatus = (state: RootState) => state.fileBlob.status;
export const selectFileBlobError = (state: RootState) => state.fileBlob.error;
